// extracted by mini-css-extract-plugin
module.exports = {"root":"ResetPassword_root__1QZ1n","button_container":"ResetPassword_button_container__2I0Cj","link":"ResetPassword_link__1Rkmx","message":"ResetPassword_message__2OunN"};